import { render, staticRenderFns } from "./KaresMsg.vue?vue&type=template&id=5b448238&scoped=true"
import script from "./KaresMsg.vue?vue&type=script&lang=js"
export * from "./KaresMsg.vue?vue&type=script&lang=js"
import style0 from "./KaresMsg.vue?vue&type=style&index=0&id=5b448238&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b448238",
  null
  
)

export default component.exports